import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';

@Component({
  selector: "app-app-install-modal",
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="app-install-modal">
      <button
        type="button"
        class="btn-close"
        (click)="activeModal.dismiss()"
        aria-label="Fermer"
      >
        ×
      </button>

      <div class="modal-split">
        <!-- Partie gauche : Téléphone + branding -->
        <div class="modal-left">
          <div class="phone-visual">
            <div class="phone-mockup">
              <div class="phone-screen">
                <!-- <div class="play-overlay">
                  <div class="play-btn">
                    <i class="fas fa-play"></i>
                  </div>
                </div> -->
                <img
                  [src]="appPreviewImage"
                  alt="Aperçu écran d'accueil YokaStar"
                  class="app-home-screen"
                />
              </div>
            </div>
          </div>
          <!-- <div class="brand-text">
            <span class="brand-yoka">YOKA</span>
            <span class="brand-star">STAR</span>
          </div> -->
        </div>

        <!-- Partie droite : Texte + boutons (fond #c74a1f) -->
        <div class="modal-right">
          <span class="badge-nouveau">NOUVEAU</span>
          <h2 class="modal-headline">Meilleure Experience Yokastar sur mobile</h2>
          <p class="modal-desc">
            Suivez vos stars préférées, demandez des dédicaces et regardez des
            lives exclusifs partout avec vous.
          </p>
          <div class="store-buttons">
            <a
              [href]="appStoreUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="store-btn"
            >
              <svg
                viewBox="0 0 24 24"
                fill="currentColor"
                width="28"
                height="28"
              >
                <path
                  d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"
                />
              </svg>
              <span class="store-text">
                <small>Télécharger sur</small>
                <strong>App Store</strong>
              </span>
            </a>
            <a
              [href]="googlePlayUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="store-btn"
            >
              <svg
                viewBox="0 0 24 24"
                fill="currentColor"
                width="28"
                height="28"
              >
                <path
                  d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.5,12.92 20.16,13.19L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"
                />
              </svg>
              <span class="store-text">
                <small>Disponible sur</small>
                <strong>Google Play</strong>
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      .app-install-modal {
        background: white;
        border-radius: 7px;
        overflow: hidden;
        box-shadow: 0 24px 48px rgba(0, 0, 0, 0.15);
        position: relative;
        height: 400px;
        padding-top: 20px;
      }

      .btn-close {
        position: absolute;
        top: 12px;
        right: 12px;
        width: 32px;
        height: 32px;
        padding: 0;
        border-radius: 50%;
        background: rgba(0, 0, 0, 0.2);
        border: none;
        color: #ffffff;
        opacity: 0.95;
        transition: all 0.2s;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 10;
        font-size: 14px;
      }

      .btn-close:hover {
        opacity: 1;
        background: rgba(0, 0, 0, 0.35);
      }

      .modal-split {
        display: flex;
        min-height: 320px;
      }

      /* Partie gauche - transparente pour laisser voir le dégradé */
      .modal-left {
        flex: 0 0 42%;
        background: transparent;
        padding: 32px 24px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
      }

      .phone-visual {
        position: relative;
        z-index: 2;
      }

      .phone-mockup {
        width: 150px;
        height: 300px;
        background: #2a2a2a;
        border-radius: 18px;
        padding: 3px 3px;
        box-shadow: 0 12px 32px rgba(0, 0, 0, 0.25);
        border: 2px solid #9ca3af;
      }

      .phone-screen {
        width: 100%;
        height: 100%;
        border-radius: 12px;
        overflow: hidden;
        background: #1a1a1a;
        position: relative;
      }

      .app-home-screen {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .play-overlay {
        position: absolute;
        inset: 0;
        background: rgba(0, 0, 0, 0.4);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1;
      }

      .play-btn {
        width: 48px;
        height: 48px;
        background: #c74a1f;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ffffff;
        font-size: 18px;
      }
      .modal-content {
        border-radius: 20px !important;
      }

      .brand-text {
        margin-top: 16px;
        display: flex;
        gap: 4px;
        font-weight: 800;
        font-size: 18px;
        letter-spacing: 0.05em;
      }

      .brand-yoka {
        color: #c74a1f;
      }
      .brand-star {
        color: #94a3b8;
      }

      /* Partie droite - transparente pour laisser voir le dégradé */
      .modal-right {
        flex: 1;
        background: transparent;
        padding: 28px 24px 32px;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }

      .badge-nouveau {
        display: inline-block;
        background: #a63d1a;
        color: #ffffff;
        font-size: 10px;
        font-weight: 700;
        letter-spacing: 0.08em;
        padding: 4px 10px;
        border-radius: 20px;
        margin-bottom: 16px;
        width: fit-content;
      }

      .modal-headline {
        font-size: 22px;
        font-weight: 800;
        // color: #ffffff;
        margin: 0 0 12px;
        line-height: 1.3;
      }

      .modal-desc {
        font-size: 13px;
        // color: rgba(255, 255, 255, 0.9);
        line-height: 1.5;
        margin: 0 0 24px;
      }

      .store-buttons {
        display: flex;
        flex-direction: column;
        gap: 10px;
      }

      .store-btn {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 12px 16px;
        background: #0f172a;
        color: #ffffff;
        border-radius: 12px;
        text-decoration: none;
        transition: all 0.2s;
      }

      .store-btn:hover {
        background: #313131;
        transform: translateX(2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      }

      .store-btn svg {
        color: #ffffff;
        flex-shrink: 0;
      }

      .store-text {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 0;

        small {
          font-size: 10px;
          color: #d6d8da;
        }

        strong {
          font-size: 15px;
          font-weight: 700;
          color: #ffffff;
        }
      }

      @media (max-width: 576px) {
        .modal-split {
          flex-direction: column;
        }

        .modal-left {
          flex: none;
          padding: 24px 20px;
        }

        .modal-right {
          padding: 24px 20px;
        }
      }
    `,
  ],
})
export class AppInstallModalComponent {
  appPreviewImage = "assets/images/explore/app-home-screen.png";
  appStoreUrl = "https://apps.apple.com/app/yokastar";
  googlePlayUrl = "https://play.google.com/store/apps/details?id=com.hologram.yokastar_mobile";

  constructor(public activeModal: NgbActiveModal) {}
}
